import React, { useState, useEffect } from 'react';
//import { useParams } from "react-router-dom";
import { Link } from 'react-router-dom';
import NavbarBottom from './NavbarBottom';


function SopJdih() {
    //const params = useParams();
    const [newsDetail, SetNewsDetail] = useState([]);
    //const urlImg = `${process.env.REACT_APP_BASEURL}/images/news/`;

    /*function handleScroll() {
        const element = document.getElementById('targetElement');
        const offset = 10;
        const bodyRect = document.body.getBoundingClientRect().top;
        const elementRect = element.getBoundingClientRect().top;
        const elementPosition = elementRect - bodyRect;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });

    }*/

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_ENDPOINT}/sop-jdih`)
            .then((res) => {
                return res.json();
            })
            .then((datas) => {
                //console.log(datas.data);
                SetNewsDetail(datas.data);
            });

       //handleScroll();
        //console.log(newsDetail);
    }, []);

    const getLang = localStorage.getItem('lang_code');

    return (
        <>
            <NavbarBottom />
            <div className="p-4 bg-[#e9f3fd]">
                <div class="flex flex-wrap items-center justify-center">
                    {/*<div class="w-full md:w-3/12 px-4 mb-8">
                        <div class="bg-gray-100 px-4 py-6">
                            <h3 class="font-bold text-left" style={{ fontFamily: 'MuseoSansRounded900', fontSize: 18 }}>
                                <span class="text-[#000]">
                                    {getLang === 'id' ? 'PROFIL KAMI' : 'PROFIL KAMI'}
                                </span>
                            </h3>
                        </div>
                        <div class="flex flex-col divide-y dark:divide-gray-300 bg-white px-4" style={{ fontFamily: 'MuseoSansRounded900', fontSize: 14 }}>
                            <div class="flex px-1 py-4">
                                <div class="flex flex-col flex-grow">
                                    <Link to="/about">
                                        Visi Misi
                                    </Link>
                                </div>
                            </div>
                            <div class="flex px-1 py-4">
                                <div class="flex flex-col flex-grow">
                                    <Link to="/dasar-hukum">
                                        Dasar Hukum
                                    </Link>
                                </div>
                            </div>
                            <div class="flex px-1 py-4">
                                <div class="flex flex-col flex-grow">
                                    <Link to="/struktur-organisasi">
                                        Struktur Organisasi Bagian Hukum
                                    </Link>
                                </div>
                            </div>
                            <div class="flex px-1 py-4">
                                <div class="flex flex-col flex-grow">
                                    <Link to="/anggota-jdih">
                                        Anggota JDIH Kota Magelang
                                    </Link>
                                </div>
                            </div>
                            <div class="flex px-1 py-4">
                                <div class="flex flex-col flex-grow">
                                    <Link to="/anggota-jdih">
                                        Anggota JDIH Kota Magelang
                                    </Link>
                                </div>
                            </div>
                            <div class="flex px-1 py-4">
                                <div class="flex flex-col flex-grow">
                                    <Link to="/sop-jdih">
                                        SOP
                                    </Link>
                                </div>
                            </div>
                        </div>


                    </div>*/}

                    <div class="bg-white w-full px-4 mb-8 rounded"><br />
                        {/*<h2 class="text-4xl font-bold mt-4 mb-2" style={{ fontFamily: 'MuseoSansRounded900', fontSize: 24 }}>
                        {getLang === 'id' ?
                            'VISI MISI'
                            :
                            'VISI MISI'
                        }
                    </h2>*/}
                        <p class="text-gray-700 mb-4" style={{ fontFamily: 'MuseoSansRounded900', fontSize: 12, justifyContent: 'center', justifyItems: 'center', display: 'flex' }}>
                            {getLang === 'id' ?
                                <div dangerouslySetInnerHTML={{ __html: newsDetail.isi }}></div>
                                :
                                <div dangerouslySetInnerHTML={{ __html: newsDetail.isi }}></div>
                            }
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SopJdih;
